import ptBR from './pt-BR';
import en from './en';

const messages = {
  'pt-BR': ptBR,
  en,
};

export default messages;



// WEBPACK FOOTER //
// ../utils/i18n/messages/index.js